export default "__VITE_ASSET__DUAfEC1q__"